import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
import { salon } from '../../data/content';
import { ease } from '../../core/format/motion';
type Props = {
  message: string | null;
  className?: string;
  /** Om de melding aan een veld te koppelen (`aria-describedby` / `aria-errormessage`). */
  id?: string;
};

/** Vriendelijke foutmelding bij versturen — altijd met een uitweg via WhatsApp. */
export function FormError({
  message,
  className = '',
  id
}: Props) {
  const reduce = useReducedMotion();
  // "Server fout." → "server fout": past in de zin, zonder dubbele punt.
  const text = message ? (message.charAt(0).toLowerCase() + message.slice(1)).replace(/[.!]+$/, '') : '';
  return <AnimatePresence initial={false} data-id="element-8664" data-mp="1jsd54xwdfa7y">
      {message && <motion.div id={id} role="alert" initial={reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: -4
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.18,
      ease
    }} className={`flex items-start gap-2.5 border border-clay/40 bg-blush px-4 py-3 text-[14px] leading-relaxed text-ink ${className}`} data-id="element-8665" data-mp="1xr4ds4sgs3op">
          {/* Korte horizontale tik bij elke (nieuwe) fout: laat zien dát en wáár het misging, zonder te schreeuwen. */}
          <motion.span key={text} className="flex items-start gap-2.5" initial={false} animate={reduce ? undefined : {
        x: [0, -3, 3, -2, 0]
      }} transition={{
        duration: 0.24,
        ease: 'easeOut'
      }} data-id="element-8666" data-mp="2uxyzt8s64f2n">
            <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-8667" data-mp="38oue50lfrodm" />
            <span data-id="element-8668" data-mp="3dnx5ji8htw34">
              Het versturen lukte niet: {text}. Probeer het nog eens, of{' '}
              <a href={salon.whatsapp} className="underline underline-offset-2" data-id="element-8669" data-mp="3injj5ss8hecg">
                app ons direct
              </a>
              .
            </span>
          </motion.span>
        </motion.div>}
    </AnimatePresence>;
}